import { Box, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Tooltip } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { MdEdit } from 'react-icons/md'
import { Button } from 'src/Common/ui/button'
import '../../Styles/ViewRiskById.css'
import { useLocation, useNavigate, useParams } from 'react-router'
import Loading from 'src/Common/ui/Loading'
import { toast } from 'react-toastify'
import * as RoutePath from '../../Entities/RoutePath'
import { cn } from 'src/lib/utils'
import * as RiskType from '../../Entities/RiskTypes'

import * as EndPoints from '../../Entities/EndPoints'
import { useGovernanceStore } from '../Onboarding/Store/GovernanceStore'

import { STATUS_ENUMS } from 'src/Entities/StatusEnums'
// import { UPDATE_RISK } from 'src/Entities/Features'
import { Card } from 'src/Common/ui/card'
import { INITIATE } from 'src/Entities/CommonEntities'
import Axios from 'src/Axios'
import AddIssue from './AddIssue'
import { useIssueStore } from './store/IssueStore'
import { VerticalTimelineContainer } from '../Governance/VerticalTimeline/VerticalTimelineContainer'
import { PeriodicityContainer } from '../Governance/Periodicity/PeriodicityContainer'
import ViewComments from '../Risk/ViewComments'
import CommentsDrawer from '../Risk/CommentsDrawer'
import IssueInformation from './IssueInformation'
import IssueAnalyze from './IssueAnalyze'
import IssueAnalyzeEdit from './IssueAnalyzeEdit'
import { ISSUE_STATUS, RESOLUTION_APPROACH, RESOLUTION_ID } from 'src/Entities/IssueTypes'
import IssuePlanning from './IssuePlanning'
import IssuePlanningEdit from './IssuePlanningEdit'
import IssueMonitoring from './IssueMonitoring'
import IssueMonitoringEdit from './IssueMonitoringEdit'
import IssuePendingEdit from './IssuePendingEdit'
import IssuePending from './issuePending'

const ViewIssueById = () => {
    const instance = Axios.getInstance()

    const { getIssueDetailsById, getIssueHistory, getIssuePeriodicity } = useIssueStore()
    const issueDetailsData = useIssueStore(state => state.issueDetailsById)
    const IssueDetailsByIdLoading = useIssueStore(state => state.IssueDetailsByIdLoading)
    const issueDetailsLoading = useIssueStore(state => state.issueDetailsLoading)
    const createIssueDataLoading = useIssueStore(state => state.createIssueDataLoading)
    const getIssueHistoryData = useIssueStore((state) => state.getIssueHistoryData)
    const params = useParams()
    const [ isEditTrue, setIsEditTrue ] = useState(false)
    const [ formData, setformData ] = useState({})
    const [ riskTypes, setRiskTypes ] = useState([])
    const [ allCategories, setAllCategories ] = useState([])
    const [ openWithdrawnPopup, setOpenWithdrawnPopup ] = useState(false)
    const [ impactedDepartments, setImpactedDepartments ] = useState([])
    const [ issueStatusTabs, setIssueStatusTabs ] = useState(ISSUE_STATUS.ISSUE_INFO)
    const [ riskScore, setRiskScore ] = useState([{ impact: null, Probability: null, RiskScore: null }])
    const loginId = localStorage.getItem('userId')

    const userName = localStorage.getItem('userName')
    const navigate = useNavigate()
    const location = useLocation()
    const riskDetails = location?.state?.issueDetails
    const checkedCount = issueDetailsData?.moniteringResponse?.taskLists?.filter((filData, _) => filData?.actions !== 11)?.filter(item => item.actions === RiskType.TASK_COMPLETED_STATUS).length
    const taskPercentage = (checkedCount / issueDetailsData?.moniteringResponse?.taskLists?.filter((filData, _) => filData?.actions !== 11)?.length) * 100

    const [ openConfirmDialog, setOpenConfirmDialog ] = useState(false)
    const [ CommentsDrawerTitle, setCommentsDrawerTitle ] = useState('')

    const [ statusEnum, setStatusEnum ] = useState({
        status: 1,
        level1: 8,
        level2: 8
    })
    useEffect(() => {
        if (params?.issueId) {
            getIssueDetailsById(Number(riskDetails?.issueId), loginId)
        }
    }, [params?.issueId])

    const getAllIssueTypes = async () => {
        try {
            const response = await instance.get(EndPoints.API_ENDPOINT + '/masterController/GetAllIssueTypes')
            return response.data
        } catch (error) {
            console.error('Error fetching risk types:', error)
            throw error
        }
    }

    const getAllCategories = async () => {
        try {
            const response = await instance.get(EndPoints.API_ENDPOINT + '/masterController/GetAllCategories')
            return response.data
        } catch (error) {
            console.error('Error fetching categories:', error)
            throw error
        }
    }
    const { getDepOrganizations, allDepartments } = useGovernanceStore()
    const orgId = localStorage.getItem('orgId')
    // useEffect(() => {
    //     if (!isEditTrue) {
    //         getIssueDetailsById(riskDetails?.issueId, userId)
    //     }
    // }, [isEditTrue])
    useEffect(() => {
        if (allDepartments.length > 0) {
            setImpactedDepartments(allDepartments)
        }
    }, [allDepartments])

    useEffect(() => {
        const fetchRiskTypes = async () => {
            try {
                const types = await getAllIssueTypes()
                setRiskTypes(types)
            } catch (error) {
                console.error('Error fetching risk types:', error)
            }
            try {
                const types = await getAllCategories()
                setAllCategories(types)
            } catch (error) {
                console.error('Error fetching all categories:', error)
            }
            try {
                getDepOrganizations(orgId)
            } catch (error) {
                console.error('Error fetching imp dept:', error)
            }
        }

        fetchRiskTypes()
    }, [])

    useEffect(() => {
        if (issueDetailsData?.issueInformation?.id) {
            setStatusEnum({ ...statusEnum, status: issueDetailsData?.issueInformation?.status, level1: issueDetailsData?.issueInformation?.level1, level2: issueDetailsData?.issueInformation?.level2 })
            setformData({
                ...formData,
                id: issueDetailsData?.issueInformation?.id,
                ContextId: issueDetailsData?.issueInformation?.contextId,
                Title: issueDetailsData?.issueInformation?.title,
                Description: issueDetailsData?.issueInformation?.description,
                IdentifiedOn: issueDetailsData?.issueInformation?.identifiedOn,
                IssueType: riskTypes?.find((findDt) => findDt?.name === issueDetailsData?.issueInformation?.type)?.id,
                Category: allCategories?.find((findDt) => findDt?.name === issueDetailsData?.issueInformation?.category)?.id,
                ImpactedDepartnments: issueDetailsData?.issueInformation?.impactedDepartment?.map((str) => {
                    const foundObj = impactedDepartments?.find((obj) => obj.name === str)
                    return foundObj ? foundObj.id : null
                }),
                ImpactOfIssue: issueDetailsData?.issueInformation?.issueScore[0]?.impactOfRisk,
                RiskOwner: impactedDepartments?.find((findDt) => findDt?.name === issueDetailsData?.issueInformation?.ownerDepartmentId)?.id,
                CreatedBy: issueDetailsData?.issueInformation?.createdBy,
                CreatedDate: issueDetailsData?.issueInformation?.createdAt,
                SupportingDocuments: issueDetailsData?.issueInformation?.supportingDocuments || [],

                internalExternal: issueDetailsData?.issueInformation?.source || issueDetailsData?.issueInformation?.sourceIssueId,
                issueScore: issueDetailsData?.issueInformation?.issueScore?.map((mapData) => {
                    return {
                        id: mapData?.id,
                        riskId: mapData?.riskId,
                        user: mapData?.user,
                        userId: mapData?.userId,
                        role: mapData?.role,
                        status: mapData?.status,
                        impact: mapData?.impact,
                        Probability: mapData?.probability,
                        RiskScore: mapData?.riskScore,
                        ImpactOfRisk: mapData?.impactOfRisk
                    }
                }),
                mitigationTasks: issueDetailsData?.issueInformation?.ResolutionPlan?.map((mapDt) => {
                    return { ...mapDt, task: mapDt?.name }
                })
            })
        }

        if (issueDetailsData?.issueInformation?.status === STATUS_ENUMS.Analyze) {
            setIssueStatusTabs(ISSUE_STATUS.ISSUE_INFO)
        } else if (issueDetailsData?.issueInformation?.status === STATUS_ENUMS.Mitigation && issueDetailsData.issueInformation?.department !== userDepartment) {
            setIssueStatusTabs(ISSUE_STATUS.PLAN)
        } else if (issueDetailsData?.issueInformation?.status === STATUS_ENUMS.Monitering) {
            setIssueStatusTabs(ISSUE_STATUS.MONITORING)
        } else if (issueDetailsData?.issueInformation?.status === STATUS_ENUMS.Pending || issueDetailsData?.issueInformation?.status === STATUS_ENUMS.Completed) {
            setIssueStatusTabs(ISSUE_STATUS.PENDING_FOR_REVIEW)
        } else {
            setIssueStatusTabs(ISSUE_STATUS.ISSUE_INFO)
        }
    }, [ issueDetailsData?.issueInformation?.id, allCategories?.length, impactedDepartments?.length, riskTypes?.length ])
    const handleClickEdit = () => {
        setIsEditTrue(!isEditTrue)
        if (issueStatusTabs === RiskType.ASSESSMENT_STATUS) {
            const threePointEstimate = issueDetailsData?.analyzeResponse?.threePointEstimate
            const decisionTreeAnalysis = issueDetailsData?.analyzeResponse?.decisionTreeAnalysis
            const expectedMonetaryValue = issueDetailsData?.analyzeResponse?.expectedMonetaryValue
            const qualitativeRiskAssessment = issueDetailsData?.analyzeResponse?.qualitativeRiskAssessment
            if (issueStatusTabs === RiskType.ASSESSMENT_STATUS) {
                setRiskScore(
                    {
                        ...riskScore,
                        id: qualitativeRiskAssessment?.id,
                        riskId: qualitativeRiskAssessment?.riskId,
                        user: qualitativeRiskAssessment?.user,
                        userId: qualitativeRiskAssessment?.userId,
                        role: qualitativeRiskAssessment?.role,
                        status: qualitativeRiskAssessment?.status,
                        impact: qualitativeRiskAssessment?.impact,
                        Probability: qualitativeRiskAssessment?.probability,
                        RiskScore: qualitativeRiskAssessment?.riskScore
                    }
                )
            } else {
                setRiskScore({
                    ...riskScore,
                    id: qualitativeRiskAssessment?.id,
                    riskId: qualitativeRiskAssessment?.riskId,
                    user: qualitativeRiskAssessment?.user,
                    userId: qualitativeRiskAssessment?.userId,
                    role: qualitativeRiskAssessment?.role,
                    status: qualitativeRiskAssessment?.status,
                    impact: qualitativeRiskAssessment?.impact,
                    Probability: qualitativeRiskAssessment?.probability,
                    RiskScore: qualitativeRiskAssessment?.riskScore
                })
            }
            setformData({
                ...formData,
                ImpactOfRiskScore: qualitativeRiskAssessment?.impactOfRisk,
                impactProbabilityJustification: qualitativeRiskAssessment?.probabilityJustification,
                threePointEstimate: {
                    // ...formData?.threePointEstimate,
                    id: threePointEstimate?.id,
                    riskId: threePointEstimate?.riskId,
                    estimateId: threePointEstimate?.estimateId,
                    treePointDiscription: threePointEstimate?.description,
                    optimisticCost: threePointEstimate?.optimisticCost,
                    optimisticDays: threePointEstimate?.optimisticDays,
                    pessimisticDays: threePointEstimate?.pessimisticDays,
                    pessimisticCost: threePointEstimate?.pessimisticCost,
                    mostLikelyDays: threePointEstimate?.mostLikelyDays,
                    mostLikelyCost: threePointEstimate?.mostLikelyCost,
                    durationEstimation: threePointEstimate?.durationEstimation,
                    costEstimation: threePointEstimate?.costEstimation
                },
                decisionTreeAnalysis: {
                    // ...formData?.decisionTreeAnalysis,
                    decisionDiscription: decisionTreeAnalysis?.description,
                    bestDaysAlternative: decisionTreeAnalysis?.dayDecision,
                    bestCostAlternative: decisionTreeAnalysis?.costDecision,
                    noOfAlternatives: decisionTreeAnalysis?.alternativesNo,
                    id: decisionTreeAnalysis?.id,
                    riskId: decisionTreeAnalysis?.alternativesNo > 0 ? decisionTreeAnalysis?.riskId : 0,
                    decisionId: decisionTreeAnalysis?.alternativesNo > 0 ? decisionTreeAnalysis?.decisionId : 0,
                    alternativesData: decisionTreeAnalysis?.alternatives?.map((mapData) => {
                        return {
                            id: mapData?.id,
                            decisionTreeId: mapData?.decisionTreeId,
                            alternativeName: mapData?.alternativeName,
                            noOfOutcome: mapData?.outcomeNo,
                            outcomesData: mapData?.outcomes?.map((childMapData) => {
                                return {
                                    id: childMapData?.id,
                                    alternativeId: childMapData?.alternativeId,
                                    outComesDiscription: childMapData?.outcomeDescription,
                                    outComesProbability: childMapData?.probability,
                                    outComesCost: childMapData?.cost,
                                    outComesDays: childMapData?.days
                                }
                            })
                        }
                    })
                },
                noOfRisks: expectedMonetaryValue?.risksNo,
                emvId: expectedMonetaryValue?.id,
                totalEMV: expectedMonetaryValue?.totalEMV,
                noOfRisksData: expectedMonetaryValue?.inputs?.map((mapData) => {
                    return {
                        id: mapData?.id,
                        riskId: expectedMonetaryValue?.risksNo > 0 ? mapData?.riskId : 0,
                        emvId: mapData?.emvId,
                        riskName: mapData?.riskName,
                        probability: mapData?.probability,
                        cost: mapData?.cost
                    }
                })
            })
        }
    }

    const handleClickTab = (value) => {
        setIssueStatusTabs(value)
        setIsEditTrue(false)
    }

    const userDepartment = localStorage.getItem('department')
    const userId = localStorage.getItem('userId')
    const userRoles = JSON.parse(localStorage.getItem('userRoles'))
    const RaisedManagerValidation = () => {
        return issueDetailsData.issueInformation?.department === userDepartment && verifyManagerOrVacant()
    }
    const ownedManagerValidation = () => {
        return issueDetailsData.issueInformation?.ownerDepartmentId === userDepartment && verifyManagerOrVacant()
    }
    const RaisedManagerCloseValidation = () => {
        return (issueDetailsData?.issueInformation?.status === STATUS_ENUMS.Completed || issueDetailsData?.issueInformation?.status === STATUS_ENUMS.MitigationCompleted) && issueDetailsData.issueInformation?.department === userDepartment && verifyManagerOrVacant()
    }
    const addRiskRef = useRef()
    const handleApprove = (type = null, message) => {
        let status = statusEnum
        if (RaisedManagerValidation()) {
            status = { ...status, level1: STATUS_ENUMS.Approved, status: STATUS_ENUMS.Active }
            setStatusEnum({ ...statusEnum, level1: STATUS_ENUMS.Approved, status: STATUS_ENUMS.Active })
        }
        if (ownedManagerValidation()) {
            if (type === 'Planning') {
                const find = RESOLUTION_APPROACH.find((ele) => issueDetailsData?.planningResponse?.approachId === RESOLUTION_ID && ele.value === issueDetailsData?.planningResponse?.approachId)
                if (find) {
                    status = { ...status, status: STATUS_ENUMS.Monitering }
                    setStatusEnum({ ...statusEnum, status: STATUS_ENUMS.Monitering })
                } else {
                    status = { ...status, status: issueDetailsData?.planningResponse?.approachId !== RESOLUTION_ID ? STATUS_ENUMS.MitigationCompleted : STATUS_ENUMS.Completed }
                    setStatusEnum({ ...statusEnum, status: issueDetailsData?.planningResponse?.approachId !== RESOLUTION_ID ? STATUS_ENUMS.MitigationCompleted : STATUS_ENUMS.Completed })
                }
            } else if (type === 'Monitoring') {
                if (issueDetailsData?.issueInformation?.status === STATUS_ENUMS.Monitering) {
                    status = { ...status, status: STATUS_ENUMS.Pending }
                    setStatusEnum({ ...statusEnum, status: STATUS_ENUMS.Pending })
                }
            } else if (type === 'Close') {
                if (issueDetailsData?.issueInformation?.status === STATUS_ENUMS.Completed) {
                    status = { ...status, status: STATUS_ENUMS.Closed }
                    setStatusEnum({ ...statusEnum, status: STATUS_ENUMS.Closed })
                }
            } else {
                setStatusEnum({ ...statusEnum, status: STATUS_ENUMS.Analyze })
                status = { ...status, status: STATUS_ENUMS.Analyze }
            }
        }
        if (RaisedManagerCloseValidation()) {
            // eslint-disable-next-line no-unused-vars
            status = { ...status, status: STATUS_ENUMS.Closed }
        }
        handleAddRisk(status, message)

        // callBack()
    }
    // const customNavigate = useCustomNavigate()
    const [ loading, setLoading ] = useState(false)
    const { CreateIssue } = useIssueStore()
    const handleAddRisk = async (status, message) => {
        setLoading(true)
        try {
            const selectedFiles = formData?.SupportingDocuments || []
            const commentType = issueDetailsData?.issueInformation?.department === userDepartment ? 'raisedRemarks' : 'ownerRemarks'
            const addRiskFormate = {
                IssueId: formData?.id,
                // ContextId: formData?.ContextId,
                Title: formData?.Title,
                Description: formData?.Description,
                IdentifiedOn: formData?.IdentifiedOn,
                SourceIssueId: formData.internalExternal === 'New' ? 1 : 2,
                IssueType: formData?.IssueType,
                // Category: formData?.Category,
                ImpactedDepartmentIds: formData?.ImpactedDepartnments,
                OwnerDepartmentId: formData?.RiskOwner,
                Scores: formData.issueScore?.map((mapData) => {
                    return {
                        id: mapData.id,
                        riskId: isEditTrue ? formData?.id : 0,
                        levelId: 1,
                        userId: mapData?.userId || loginId,
                        user: mapData?.user || userName,
                        impact: mapData?.impact,
                        probability: mapData?.Probability,
                        riskScore: mapData?.RiskScore,
                        impactOfRisk: mapData?.ImpactOfRisk,
                        probabilityJustification: '',
                        createdBy: loginId,
                        createdAt: new Date()?.toISOString(),
                        modifiedBy: loginId,
                        modifiedAt: new Date()?.toISOString(),
                        status: STATUS_ENUMS.Active
                    }
                }),
                ResolutionPlan: formData.mitigationTasks?.map(mapDt => {
                    return {
                        id: mapDt.id,
                        riskId: mapDt.riskId,
                        name: mapDt?.task,
                        startDate: typeof mapDt?.startDate === 'object' ? mapDt?.startDate?.toISOString() : mapDt?.startDate || '',
                        endDate: typeof mapDt?.endDate === 'object' ? mapDt?.endDate?.toISOString() : mapDt?.endDate || '',
                        departmentId: '',
                        actions: mapDt?.actions || '',
                        responsible: '',
                        createdBy: mapDt?.createdBy || loginId,
                        createdAt: new Date().toISOString(),
                        modifiedBy: mapDt?.modifiedBy || loginId,
                        modifiedAt: new Date().toISOString(),
                        status: mapDt.status
                    }
                }),
                // Level1: status.level1,
                // Level2: message === 'Risk [ID] has been accepted' && (L1Approval && !L2Approval) ? STATUS_ENUMS.Approved : status.level2,
                [commentType]: comments,
                CreatedBy: isEditTrue ? formData?.CreatedBy : loginId,
                CreatedAt: isEditTrue ? formData?.CreatedDate : new Date().toISOString(),
                ModifiedBy: loginId,
                ModifiedAt: new Date().toISOString(),
                Status: status.status
            }

            const formValue = new FormData()

            Object.entries(addRiskFormate).forEach(([ key, value ]) => {
                if (Array.isArray(value)) {
                    if (key === 'Scores') {
                        value.forEach((score, index) => {
                            Object.entries(score).forEach(([ scoreKey, scoreValue ]) => {
                                formValue.append(`Scores[${index}].${scoreKey}`, scoreValue)
                            })
                        })
                    } else if (key === 'ImpactedDepartmentIds') {
                        addRiskFormate?.ImpactedDepartmentIds?.forEach((deptId, index) => {
                            formValue.append(`ImpactedDepartmentIds[${index}]`, deptId)
                        })
                    } else if (key === 'ResolutionPlan') {
                        addRiskFormate?.ResolutionPlan?.forEach((task, index) => {
                            Object.entries(task).forEach(([ taskKey, taskValue ]) => {
                                formValue.append(`ResolutionPlan[${index}].${taskKey}`, taskValue)
                            })
                        })
                    } else {
                        value.forEach(item => formValue.append(key, item))
                    }
                } else {
                    formValue.append(key, value)
                }
            })

            selectedFiles?.forEach((task, index) => {
                Object.entries(task).forEach(([ taskKey, taskValue ]) => {
                    formValue.append(`SupportingDocuments[${index}].${taskKey}`, taskValue)
                })
            })
            await CreateIssue(loginId, formValue)
                .then(async (res) => {
                    if (res.data === 'Failed to add risk: Risk Withdrawn') {
                        setOpenWithdrawnPopup(true)
                        setEditState({ right: false })
                    } else if (res?.data) {
                        toast.success(<p className='w-[100%] flex flex-row justify-evenly items-center' ><p>{message?.replace('[ID]', res?.data)}</p></p>, {
                            position: 'top-right', theme: 'light'
                        })
                        setEditState({ right: false })
                        setEditState({ right: false })
                        if (message === 'Issue [ID] has been closed') {
                            navigate(RoutePath.MAIN_CONTAINER.MAIN + RoutePath.ISSUE.HISTORY)
                        }
                        // else if (message === 'Risk [ID] has been successfully withdrawn') {
                        //     navigate(RoutePath.MAIN_CONTAINER.MAIN + RoutePath.RISK.URI + '/' + INITIATE)
                        // } else if (message === 'Risk [ID] has been accepted') {
                        //     setLoading(true)
                        //     instance.post(EndPoints.API_ENDPOINT + `/risk/RiskHistoryUpdateEntry?riskId=${formData?.id}&loginId=${loginId}&type=2`)
                        //         .then((tmlnRes) => tmlnRes)
                        //         .catch((err) => err)
                        //         .finally(() => {
                        //             setLoading(false)
                        //             navigate(RoutePath.MAIN_CONTAINER.MAIN + RoutePath.RISK.URI + '/' + INITIATE)
                        //         })
                        // } else if (message === 'Risk [ID] has been denied') {
                        //     navigate(RoutePath.MAIN_CONTAINER.MAIN + RoutePath.RISK.URI + '/' + INITIATE)
                        //     setEditState({ right: false })
                        // } else if (message === 'Risk [ID] has been rejected') {
                        //     navigate(RoutePath.MAIN_CONTAINER.MAIN + RoutePath.RISK.URI + '/' + INITIATE)
                        // } else {
                        //     if (issueDetailsData.planningResponse.approachId === STATUS_ENUMS.Approved && issueDetailsData?.issueInformation?.status === STATUS_ENUMS.Monitering) {
                        //         navigate(RoutePath.MAIN_CONTAINER.MAIN + RoutePath.RISK.URI + '/' + INITIATE)
                        //     } else if (issueDetailsData.planningResponse.approachId !== STATUS_ENUMS.Approved && issueDetailsData?.issueInformation?.status === STATUS_ENUMS.Analyze) {
                        //         navigate(RoutePath.MAIN_CONTAINER.MAIN + RoutePath.RISK.URI + '/' + INITIATE)
                        //     } else {
                        //         navigate(`${'#' + res?.data}`, { state: { riskDetails: { riskId: formData?.id } } })
                        //     }
                        // }
                        setLoading(false)
                        getIssueDetailsById(Number(riskDetails?.issueId), loginId)
                        // await getRiskDetails(1, 30, 1, 1, loginId)
                        setEditState({ right: false })
                    } else {
                        toast.error(<p className='w-[70%] flex flex-row justify-evenly items-center' ><p color='hsl(var(--card))'>Risk could not be withdrawn. Please try again!</p></p>, {
                            position: 'top-right', theme: 'light'
                        })
                    }
                    setEditState({ right: false })
                })
                .catch((err) => {
                    toast.error(<p className='w-[70%] flex flex-row justify-evenly items-center' ><p color='hsl(var(--card))'>Risk could not be withdrawn. Please try again!</p></p>, {
                        position: 'top-right', theme: 'light'
                    })
                    console.error(err)
                })
        } catch (error) {
            console.error('Error adding risk:', error)
        }
    }
    const [ comments, setComments ] = useState('')
    const [ editState, setEditState ] = useState({ right: false })
    const [ isViewComments, setIsViewComments ] = useState({ right: false })
    const ref = useRef()
    const periodRef = useRef()
    const toggleDrawer = () => {
        ref.current.toggleDraw()
    }
    const periodToggleDraw = () => {
        periodRef.current.toggleDraw()
    }
    const handleReject = (message) => {
        let status = statusEnum
        if (RaisedManagerValidation()) {
            status = { ...status, level1: STATUS_ENUMS.Rejected, status: STATUS_ENUMS.Active }
            setStatusEnum({ ...statusEnum, level1: STATUS_ENUMS.Rejected, status: STATUS_ENUMS.Active })
        }
        if (ownedManagerValidation()) {
            if (issueDetailsData?.issueInformation?.status === STATUS_ENUMS.DisputeApprove) {
                status = { ...status, level2: STATUS_ENUMS.Rejected, status: STATUS_ENUMS.DisputeClosed }
                setStatusEnum({ ...statusEnum, level2: STATUS_ENUMS.Rejected, status: STATUS_ENUMS.DisputeClosed })
            } else {
                status = { ...status, level2: STATUS_ENUMS.Rejected, status: STATUS_ENUMS.Active }
                setStatusEnum({ ...statusEnum, level2: STATUS_ENUMS.Rejected, status: STATUS_ENUMS.Active })
            }
        }
        handleAddRisk(status, message)
    }
    const handleRetrieve = (message) => {
        let status = statusEnum
        status = { ...status, level1: STATUS_ENUMS.Pending, level2: STATUS_ENUMS.Pending, status: STATUS_ENUMS.Retrieve }
        handleAddRisk(status, message)
    }
    const handleDisMove = (message) => {
        let status = statusEnum
        status = { ...status, status: STATUS_ENUMS.Dispute }
        setStatusEnum({ ...statusEnum, status: STATUS_ENUMS.Dispute })
        handleAddRisk(status, message)
    }
    const handleRejAccept = () => {
        let status = statusEnum
        status = { ...status, status: STATUS_ENUMS.RejectedAccept }
        setStatusEnum({ ...statusEnum, status: STATUS_ENUMS.RejectedAccept })
        handleAddRisk(status, 'Rejected Risk [ID] has been accepted')
    }
    const handleDisApprove = () => {
        let status = statusEnum
        status = { ...status, level2: STATUS_ENUMS.Approved, status: STATUS_ENUMS.Analyze }
        setStatusEnum({ ...statusEnum, level2: STATUS_ENUMS.Approved, status: STATUS_ENUMS.Analyze })
        handleAddRisk(status)
    }
    const handleDisReject = () => {
        let status = statusEnum
        status = { ...status, status: STATUS_ENUMS.DisputeClosed }
        setStatusEnum({ ...statusEnum, status: STATUS_ENUMS.DisputeClosed })
        handleAddRisk(status)
    }
    const historyApiCall = () => {
        getIssueHistory(issueDetailsData?.issueInformation?.id, orgId)
    }
    const periodApiCall = () => {
        getIssuePeriodicity(issueDetailsData?.issueInformation?.id, loginId, orgId)
    }
    // const features = JSON.parse(localStorage.getItem('features'))

    const confirmWithdraw = () => {
        setOpenConfirmDialog(false)
        handleAddRisk({ level1: STATUS_ENUMS.Pending, level2: STATUS_ENUMS.Pending, status: STATUS_ENUMS.Inactive }, 'Risk [ID] has been successfully withdrawn')
    }

    const verifyManagerOrVacant = () => {
        if (issueDetailsData?.issueInformation?.name === 'Vacant' && issueDetailsData?.issueInformation?.roles.includes('Risk Manager')) {
            return true
        } else if (issueDetailsData?.issueInformation?.deptManagers?.length > 0 && issueDetailsData?.issueInformation?.deptManagers?.some(ele => ele !== 'Vacant') && !Object.values(userRoles).find(value => value === 'Risk Analyst')) {
            return true
        } else if (issueDetailsData?.issueInformation?.deptManagers?.length === 1 && issueDetailsData?.issueInformation?.deptManagers?.every(ele => ele === 'Vacant')) {
            return true
        } else {
            return Object.values(userRoles).some(value => (value === 'Risk Manager' || value === 'Compliance Manager'))
        }
    }
    return (
        <div className='w-[100%] h-[100%] bg-card'>
            <Loading isLoading={issueDetailsLoading || IssueDetailsByIdLoading || createIssueDataLoading || loading} />
            <VerticalTimelineContainer timelineType={'Issue'} data={getIssueHistoryData} apiCall={historyApiCall} ref={ref} />
            <PeriodicityContainer data={getIssueHistoryData} apiCall={periodApiCall} ref={periodRef} type='ISSUE' />
            <div className='h-[10%]' style={{ borderBottom: '1px solid hsl(var(--primary-foreground))' }} >

                <Box sx={{ display: 'flex', height: '100%', width: '100%', alignItems: 'center', justifyContent: 'space-between', position: 'relative' }}>
                    {/* <div className="w-[17%] relative">
                        <div className="w-full z-10 relative">
                            <div className={cn(issueStatusTabs === ISSUE_STATUS.ISSUE_INFO && 'active', 'step')} style={{ borderRadius: '0', background: issueStatusTabs === ISSUE_STATUS.ISSUE_INFO ? 'hsl(var(--primary))' : 'hsl(var(--card))', border: '1px solid hsl(var(--grey))', borderRight: issueStatusTabs === ISSUE_STATUS.ISSUE_INFO ? '1px solid hsl(var(--primary))' : '1px solid white', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                <div className="circle">01</div>
                                <span className='text-menu'>Issue Info</span>
                            </div>
                        </div>
                        <div className='absolute right-[-16.7px] z-0 top-[-3px]'>
                            <svg width="19" height="60" viewBox="0 0 100 265" >
                                <polygon points="10,0 50,130 10,260" stroke={issueStatusTabs === ISSUE_STATUS.ISSUE_INFO ? 'hsl(var(--card))' : 'hsl(var(--grey))'} strokeWidth="2" fill={issueStatusTabs === ISSUE_STATUS.ISSUE_INFO ? 'hsl(var(--primary))' : 'hsl(var(--card))'} />
                            </svg>
                        </div>
                    </div> */}
                    <div className="stepper-container position-sticky !w-[90%]">
                        <div className='h-[100%] w-[17%] flex flex-col justify-center cursor-pointer relative' onClick={() => handleClickTab(ISSUE_STATUS.ISSUE_INFO)} >
                            <img src={issueStatusTabs === ISSUE_STATUS.ISSUE_INFO ? '/Assets/first-active-step-bg.png' : '/Assets/first-step-bg.png'} className='w-[100%] h-[45px]' style={{ position: 'relative' }} />
                            <div className={cn(issueStatusTabs === ISSUE_STATUS.ISSUE_INFO && 'active', 'step')} style={{ position: 'absolute', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                <div className="circle">01</div>
                                <span className='text-menu'>Issue Info</span>
                            </div>
                        </div>
                        {
                            ((issueDetailsData?.issueInformation?.status === STATUS_ENUMS.Analyze && issueDetailsData?.issueInformation?.ownerDepartmentId === userDepartment) || issueDetailsData?.issueInformation?.status === STATUS_ENUMS.Closed || issueDetailsData?.issueInformation?.status === STATUS_ENUMS.MitigationCompleted || issueDetailsData?.issueInformation?.status === STATUS_ENUMS.Monitering || issueDetailsData?.issueInformation?.status === STATUS_ENUMS.Completed || (issueDetailsData?.issueInformation?.ownerDepartmentId === userDepartment)) && <>
                                {issueDetailsData?.issueInformation?.status !== STATUS_ENUMS.Active &&
                                <div className='h-[100%] w-[17%] flex flex-col justify-center cursor-pointer relative' onClick={() => handleClickTab(ISSUE_STATUS.ANALYZE)} >
                                    <img src={issueStatusTabs === ISSUE_STATUS.ANALYZE ? '/Assets/second-act-step-bg.png' : '/Assets/second-step-bg.png'} className='w-[100%] h-[45px]' style={{ position: 'relative' }} />
                                    <div className={cn(issueStatusTabs === ISSUE_STATUS.ANALYZE && 'active', 'step')} style={{ position: 'absolute', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                        <div className="circle">02</div>
                                        <span className='text-menu'>Analyze</span>
                                    </div>
                                </div>}
                            </>
                        }
                        {
                            ((issueDetailsData?.issueInformation?.status !== STATUS_ENUMS.Analyze) && (issueDetailsData?.issueInformation?.status === STATUS_ENUMS.Closed || issueDetailsData?.issueInformation?.status === STATUS_ENUMS.Monitering || issueDetailsData?.issueInformation?.status === STATUS_ENUMS.Completed || issueDetailsData?.issueInformation?.status === STATUS_ENUMS.MitigationCompleted || issueDetailsData?.issueInformation?.status === STATUS_ENUMS.Pending || (issueDetailsData?.issueInformation?.ownerDepartmentId === userDepartment))) && <>
                                {issueDetailsData?.issueInformation?.status !== STATUS_ENUMS.Active && <div className='h-[100%] w-[17%] flex flex-col justify-center cursor-pointer relative' onClick={() => handleClickTab(ISSUE_STATUS.PLAN)} >
                                    <img src={issueStatusTabs === ISSUE_STATUS.PLAN ? '/Assets/second-act-step-bg.png' : '/Assets/second-step-bg.png'} className='w-[100%] h-[45px]' style={{ position: 'relative' }} />
                                    <div className={cn(issueStatusTabs === ISSUE_STATUS.PLAN && 'active', 'step')} style={{ position: 'absolute', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                        <div className="circle">03</div>
                                        <span className='text-menu'>Planning</span>
                                    </div>
                                </div>}
                            </>
                        }
                        {
                            // (issueDetailsData?.planningResponse?.approachId === RiskType.REDUCTION_ID && issueDetailsData?.issueInformation?.status !== STATUS_ENUMS.Active && issueDetailsData?.issueInformation?.status !== STATUS_ENUMS.Analyze) && <>
                            (issueDetailsData?.planningResponse?.approachId === RESOLUTION_ID && issueDetailsData?.issueInformation?.status !== STATUS_ENUMS.Active && (issueDetailsData?.issueInformation?.status === STATUS_ENUMS.Closed || issueDetailsData?.issueInformation?.status === STATUS_ENUMS.Monitering || issueDetailsData?.issueInformation?.status === STATUS_ENUMS.Completed || issueDetailsData?.issueInformation?.status === STATUS_ENUMS.MitigationCompleted || issueDetailsData?.issueInformation?.status === STATUS_ENUMS.Pending)) && <>
                                <div className='h-[100%] w-[17%] flex flex-col justify-center cursor-pointer relative' onClick={() => handleClickTab(ISSUE_STATUS.MONITORING)} >
                                    <img src={issueStatusTabs === ISSUE_STATUS.MONITORING ? '/Assets/second-act-step-bg.png' : '/Assets/second-step-bg.png'} className='w-[100%] h-[45px]' style={{ position: 'relative' }} />
                                    <div className={cn(issueStatusTabs === ISSUE_STATUS.MONITORING && 'active', 'step')} style={{ position: 'absolute', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                        <div className="circle">04</div>
                                        <span className='text-menu'>Monitoring</span>
                                    </div>
                                </div>
                            </>
                        }
                        {
                            // (issueDetailsData?.planningResponse?.approachId === RiskType.REDUCTION_ID && issueDetailsData?.issueInformation?.status !== STATUS_ENUMS.Active && issueDetailsData?.issueInformation?.status !== STATUS_ENUMS.Analyze) && <>
                            (issueDetailsData?.planningResponse?.approachId === RESOLUTION_ID && issueDetailsData?.issueInformation?.status !== STATUS_ENUMS.Active && issueDetailsData?.issueInformation?.status !== STATUS_ENUMS.Monitering && (issueDetailsData?.issueInformation?.status === STATUS_ENUMS.Closed || issueDetailsData?.issueInformation?.status === STATUS_ENUMS.Completed || issueDetailsData?.issueInformation?.status === STATUS_ENUMS.MitigationCompleted || issueDetailsData?.issueInformation?.status === STATUS_ENUMS.Pending)) && <>
                                <div className='h-[100%] w-[24%] min-w-[200px] flex flex-col justify-center cursor-pointer relative' onClick={() => handleClickTab(ISSUE_STATUS.PENDING_FOR_REVIEW)} >
                                    <img src={issueStatusTabs === ISSUE_STATUS.PENDING_FOR_REVIEW ? '/Assets/second-act-step-bg.png' : '/Assets/second-step-bg.png'} className='w-[100%] h-[45px]' style={{ position: 'relative' }} />
                                    <div className={cn(issueStatusTabs === ISSUE_STATUS.PENDING_FOR_REVIEW && 'active', 'step')} style={{ position: 'absolute', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                        <div className="circle">05</div>
                                        <span className='text-menu'>Pending For Review</span>
                                    </div>
                                </div>
                            </>
                        }
                    </div>

                    <Box className='flex'>
                        {/* <Tooltip title="Chart & TimeLine" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                            <IconButton sx={{ mr: 1 }} onClick={() => navigate(RoutePath.MAIN_CONTAINER.MAIN + RoutePath.RISK.URI + RoutePath.CHAT_AND_TIMELINE.URI + '/' + riskDetails?.riskId)}>
                                <RiChatHistoryLine color='hsl(var(--primary))' />
                            </IconButton>
                        </Tooltip> */}
                        {!isEditTrue && (issueDetailsData?.issueInformation?.ownerDepartmentId === userDepartment && verifyManagerOrVacant()) && (
                            (issueStatusTabs === ISSUE_STATUS.ANALYZE && issueDetailsData.issueInformation.status === STATUS_ENUMS.Analyze) ||
                        (issueStatusTabs === ISSUE_STATUS.PLAN && issueDetailsData.issueInformation.status === STATUS_ENUMS.Mitigation) ||
                        (issueStatusTabs === ISSUE_STATUS.MONITORING && issueDetailsData.issueInformation.status === STATUS_ENUMS.Monitering) || (issueStatusTabs === ISSUE_STATUS.PENDING_FOR_REVIEW && issueDetailsData.issueInformation.status === STATUS_ENUMS.Pending)) &&
                            <Tooltip title="Edit Issue" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                <IconButton
                                    onClick={handleClickEdit}
                                    sx={{ mr: 1 }}>
                                    <MdEdit
                                        color='hsl(var(--primary))'
                                    />
                                </IconButton>
                            </Tooltip>}

                        {/* <IconButton onClick={handleClickEdit} sx={{ mr: 1 }}>
                            <MdEdit color='hsl(var(--primary))' />
                        </IconButton> */}

                        <div className='mr-3'>
                            <Card>
                                <div className='flex justify-between gap-2 px-5 py-3'>
                                    <Tooltip className='flex-shrink-0' title="Timeline" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>

                                        <div className='cursor-pointer active:scale-90 transition-transform duration-150' onClick={() => toggleDrawer()}><img className='w-8' src='/Assets/chatTimeline.svg' /></div>
                                    </Tooltip>
                                    <div className='h-[25px] w-[1.5px] flex-shrink-0 bg-[hsl(var(--primary-table-head))]'></div>
                                    <Tooltip className='flex-shrink-0' title="Periodicity" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                        <img className='w-9 cursor-pointer flex-shrink-0' src='/Assets/analysis.svg' onClick={() => periodToggleDraw()} />
                                    </Tooltip>
                                </div>
                            </Card>
                        </div>
                    </Box>
                </Box>
                {/* <div className='prd-section'>
                    <ul className='prd-breadcrumbs-ul'>
                        <li className='w-[14%] border border-1 border-solid border-black h-[43px]'>
                            <a className={cn(issueStatusTabs === ISSUE_STATUS.ISSUE_INFO ? 'prd-section-b' : 'prd-section-a', 'w-full')}>
                                <span className='w-full h-full flex items-center' onClick={() => handleClickTab(ISSUE_STATUS.ISSUE_INFO)}>
                                    <div className={cn(issueStatusTabs === ISSUE_STATUS.ISSUE_INFO && 'active', 'w-full pr-7')} style={{ position: 'absolute', display: 'flex', flexDirection: 'row', justifyContent: 'right', alignItems: 'center' }}>
                                        <div className={cn('!text-primary text-[1rem]', 'circle')}>02</div>
                                        <span className={cn(issueStatusTabs === ISSUE_STATUS.ISSUE_INFO ? '!text-card' : '!text-primary', 'text-menu')}>Issue Info</span>
                                    </div>
                                </span>
                            </a>
                        </li>
                        <li className='w-[14%] border border-1 border-solid border-black h-[43px]'>
                            <a className={cn(issueStatusTabs === ISSUE_STATUS.ANALYZE ? 'prd-section-b' : 'prd-section-a', 'w-full')}>
                                <span className='w-full h-full flex items-center' onClick={() => handleClickTab(ISSUE_STATUS.ANALYZE)}>
                                    <div className={cn(issueStatusTabs === ISSUE_STATUS.ANALYZE && 'active', 'w-full pr-7')} style={{ position: 'absolute', display: 'flex', flexDirection: 'row', justifyContent: 'right', alignItems: 'center' }}>
                                        <div className={cn('!text-primary text-[1rem]', 'circle')}>02</div>
                                        <span className={cn(issueStatusTabs === ISSUE_STATUS.ANALYZE ? '!text-card' : '!text-primary', 'text-menu')}>Analyze</span>
                                    </div>
                                </span>
                            </a>
                        </li>
                        <li className='w-[14%] border border-1 border-solid border-black h-[43px]'>
                            <a className={cn(issueStatusTabs === ISSUE_STATUS.PLAN ? 'prd-section-b' : 'prd-section-a', 'w-full')}>
                                <span className='w-full h-full flex items-center' onClick={() => handleClickTab(ISSUE_STATUS.PLAN)}>
                                    <div className={cn(issueStatusTabs === ISSUE_STATUS.PLAN && 'active', 'w-full pr-7')} style={{ position: 'absolute', display: 'flex', flexDirection: 'row', justifyContent: 'right', alignItems: 'center' }}>
                                        <div className={cn('!text-primary text-[1rem]', 'circle')}>02</div>
                                        <span className={cn(issueStatusTabs === ISSUE_STATUS.PLAN ? '!text-card' : '!text-primary', 'text-menu')}>Planning</span>
                                    </div>
                                </span>
                            </a>
                        </li>
                        <li className='w-[15%]' >
                            <a className={cn(issueStatusTabs === ISSUE_STATUS.MONITORING ? 'prd-section-b' : 'prd-section-a', 'w-full')}>
                                <span className='w-full h-full flex items-center' onClick={() => handleClickTab(ISSUE_STATUS.MONITORING)}>
                                    <div className={cn(issueStatusTabs === ISSUE_STATUS.MONITORING && 'active', 'w-full pr-7')} style={{ position: 'absolute', display: 'flex', flexDirection: 'row', justifyContent: 'right', alignItems: 'center' }}>
                                        <div className={cn('!text-primary text-[1rem]', 'circle')}>02</div>
                                        <span className={cn(issueStatusTabs === ISSUE_STATUS.MONITORING ? '!text-card' : '!text-primary', 'text-menu')}>Monitering</span>
                                    </div>
                                </span>
                            </a>
                        </li>
                        <li className='w-[19%]' >
                            <a className={cn(issueStatusTabs === ISSUE_STATUS.PENDING_FOR_REVIEW ? 'prd-section-b' : 'prd-section-a', 'w-full')}>
                                <span className='w-full h-full flex items-center' onClick={() => handleClickTab(ISSUE_STATUS.PENDING_FOR_REVIEW)}>
                                    <div className={cn(issueStatusTabs === ISSUE_STATUS.PENDING_FOR_REVIEW && 'active', 'w-full pr-7')} style={{ position: 'absolute', display: 'flex', flexDirection: 'row', justifyContent: 'right', alignItems: 'center' }}>
                                        <div className={cn('!text-primary text-[1rem]', 'circle')}>02</div>
                                        <span className={cn(issueStatusTabs === ISSUE_STATUS.PENDING_FOR_REVIEW ? '!text-card' : '!text-primary', 'text-menu')}>Pending for Review</span>
                                    </div>
                                </span>
                            </a>
                        </li>
                    </ul>
                </div> */}
            </div>
            <div className={cn('w-full overflow-auto',
                ((!isEditTrue && issueDetailsData?.issueInformation?.department === userDepartment && verifyManagerOrVacant()) ||
                (!isEditTrue && issueDetailsData?.issueInformation?.level2 === STATUS_ENUMS.Pending && issueDetailsData?.issueInformation?.ownerDepartmentId === userDepartment && verifyManagerOrVacant()) ||
                (!isEditTrue && issueStatusTabs === ISSUE_STATUS.PLAN && issueDetailsData?.planningResponse?.approachId && issueDetailsData.issueInformation.status === STATUS_ENUMS.Mitigation && issueDetailsData?.issueInformation?.ownerDepartmentId === userDepartment && verifyManagerOrVacant()) ||
                (!isEditTrue && issueStatusTabs === ISSUE_STATUS.MONITORING && issueDetailsData?.planningResponse?.approachId && issueDetailsData.issueInformation.status === STATUS_ENUMS.Monitering && issueDetailsData?.issueInformation?.ownerDepartmentId === userDepartment && verifyManagerOrVacant()) ||
                (!isEditTrue &&
                     issueDetailsData?.issueInformation?.status === STATUS_ENUMS.Completed &&
                      issueDetailsData?.planningResponse?.approachId && issueDetailsData?.issueInformation?.department === userDepartment &&
                      verifyManagerOrVacant()) ||
                    (issueDetailsData?.issueInformation?.status === STATUS_ENUMS.Closed &&
                        verifyManagerOrVacant()) ||
                    ((
                        (!isEditTrue && issueDetailsData?.issueInformation?.status === STATUS_ENUMS.Active &&
                            issueDetailsData?.issueInformation?.level1 === STATUS_ENUMS.Rejected &&
                            issueDetailsData?.issueInformation?.level2 === STATUS_ENUMS.Pending) ||
                        ((!isEditTrue && issueDetailsData?.issueInformation?.status === STATUS_ENUMS.Active) &&

                            issueDetailsData?.issueInformation?.level2 === STATUS_ENUMS.Rejected)) &&
                        verifyManagerOrVacant()) ||
                    (issueDetailsData?.issueInformation?.status === STATUS_ENUMS.Dispute &&

                        issueDetailsData?.issueInformation?.level2 === STATUS_ENUMS.Rejected &&
                        issueDetailsData?.issueInformation?.department === userDepartment &&
                        verifyManagerOrVacant()) ||
                    (issueDetailsData?.issueInformation?.status === STATUS_ENUMS.Resubmit) ||
                    (!isEditTrue && issueDetailsData?.issueInformation?.department === userDepartment && (issueDetailsData?.issueInformation?.createdBy === +userId || verifyManagerOrVacant()) && issueDetailsData?.issueInformation?.level1 === 8) ||
                (((issueDetailsData?.issueInformation?.status === STATUS_ENUMS.Active && issueDetailsData?.issueInformation?.level1 === STATUS_ENUMS.Rejected && issueDetailsData?.issueInformation?.level2 === STATUS_ENUMS.Pending) ||
                ((issueDetailsData?.issueInformation?.status === STATUS_ENUMS.Active || issueDetailsData?.issueInformation?.status === STATUS_ENUMS.DisputeClosed) &&
                issueDetailsData?.issueInformation?.level2 === STATUS_ENUMS.Rejected)) && !isEditTrue) || issueDetailsData?.issueInformation?.status === STATUS_ENUMS.MitigationCompleted ||
            (issueDetailsData?.issueInformation?.status === STATUS_ENUMS.Resubmit))
                    ? 'h-[80%]'
                    : 'h-[90%]')} >
                {issueStatusTabs === ISSUE_STATUS.ISSUE_INFO && !isEditTrue && <>
                    <div className={cn('overflow-auto')} ><IssueInformation issueDetailsData={issueDetailsData?.issueInformation} /></div>
                </>}

                {/* <IssueAnalyze issueDetailsData={issueDetailsData?.analyzeResponse} /> */}
                {issueStatusTabs === ISSUE_STATUS.ANALYZE && !isEditTrue && <IssueAnalyze issueDetailsData={issueDetailsData?.analyzeResponse} />}
                {issueStatusTabs === ISSUE_STATUS.PLAN && !isEditTrue && <IssuePlanning />}
                {issueStatusTabs === ISSUE_STATUS.PENDING_FOR_REVIEW && !isEditTrue && <IssuePending />}
                {issueStatusTabs === ISSUE_STATUS.MONITORING && !isEditTrue && <IssueMonitoring/>}
                {issueStatusTabs === ISSUE_STATUS.ISSUE_INFO && isEditTrue && <AddIssue riskInfoData={issueDetailsData?.issueInformation}
                    ref={addRiskRef} isEditTrue={isEditTrue} statusEnum={statusEnum} setStatusEnum={setStatusEnum} handleApprove={handleApprove} handleReject={handleReject} riskInfo={issueDetailsData?.issueInformation} editFormData={formData} setIsEditTrue={setIsEditTrue} />}
                {issueStatusTabs === ISSUE_STATUS.ANALYZE && isEditTrue && <IssueAnalyzeEdit setIsEditTrue={setIsEditTrue} isEditTrue={isEditTrue} riskScore={riskScore} setRiskScore={setRiskScore} formData={formData} setformData={setformData} issueDetailsData={issueDetailsData} />}
                {issueStatusTabs === ISSUE_STATUS.PLAN && isEditTrue && <IssuePlanningEdit setIsEditTrue={setIsEditTrue} />}
                {issueStatusTabs === ISSUE_STATUS.MONITORING && isEditTrue && <IssueMonitoringEdit setIsEditTrue={setIsEditTrue} />}
                {issueStatusTabs === ISSUE_STATUS.PENDING_FOR_REVIEW && isEditTrue && <IssuePendingEdit handleAddRisk={handleAddRisk} setIsEditTrue={setIsEditTrue} />}
            </div>
            {
                !isEditTrue && issueDetailsData?.issueInformation?.level2 === STATUS_ENUMS.Pending && issueDetailsData?.issueInformation?.ownerDepartmentId === userDepartment && verifyManagerOrVacant() &&
                <div className='flex justify-end items-center gap-6 pr-4 h-[10%]'>
                    <Button onClick={() => { setEditState({ right: true }); setCommentsDrawerTitle('Reject') }}
                        variant='outline'
                        style={{ color: 'hsl(var(--destructive))', borderColor: 'hsl(var(--destructive))' }}
                        disabled={createIssueDataLoading}
                    >
                        Reject
                    </Button>
                    <Button onClick={() => handleApprove(null, 'Risk [ID] has been approved')} disabled={createIssueDataLoading}
                    >
                         Approve
                    </Button>
                </div>
            }
            {
                !isEditTrue && issueStatusTabs === ISSUE_STATUS.PLAN && issueDetailsData?.planningResponse?.approachId && issueDetailsData.issueInformation.status === STATUS_ENUMS.Mitigation && issueDetailsData?.issueInformation?.ownerDepartmentId === userDepartment && verifyManagerOrVacant() && <div className='flex justify-end items-center gap-6 pr-4 h-[10%]'><Button onClick={() => handleApprove('Planning', 'Analyze & Plan changes have been saved for Issue [ID]')} disabled={createIssueDataLoading}>
                    {issueDetailsData?.planningResponse?.approachId !== 3 ? 'Complete' : 'Submit'}
                </Button></div>
            }
            {
                !isEditTrue && issueStatusTabs === ISSUE_STATUS.MONITORING && issueDetailsData?.planningResponse?.approachId && issueDetailsData.issueInformation.status === STATUS_ENUMS.Monitering && issueDetailsData?.issueInformation?.ownerDepartmentId === userDepartment && verifyManagerOrVacant() && <div className='flex justify-end items-center gap-6 pr-4 h-[10%]'><Button disabled={Number(taskPercentage) !== 100 || createIssueDataLoading} onClick={() => handleApprove('Monitoring', 'Issue [ID] marked as complete')}>
                         Complete
                </Button></div>
            }
            {
                !isEditTrue && (issueDetailsData?.issueInformation?.status === STATUS_ENUMS.Completed || issueDetailsData?.issueInformation?.status === STATUS_ENUMS.MitigationCompleted) && issueDetailsData?.planningResponse?.approachId && issueDetailsData?.issueInformation?.department === userDepartment && verifyManagerOrVacant() && <div className='flex justify-end items-center gap-6 pr-4 h-[10%]'><Button onClick={() => handleApprove('Close', 'Issue [ID] has been closed')} disabled={createIssueDataLoading}>
                         Close Issue
                </Button></div>
            }
            {
                (((issueDetailsData?.issueInformation?.status === STATUS_ENUMS.Closed || issueDetailsData?.issueInformation?.status === STATUS_ENUMS.RejectedAccept) && issueDetailsData?.issueInformation.level2 === STATUS_ENUMS.Approved) || issueDetailsData?.issueInformation?.status === STATUS_ENUMS.RejectedAccept) && verifyManagerOrVacant() && !isEditTrue &&
                    <div className='flex justify-end items-center gap-6 pr-4 h-[10%]'>
                        <Button onClick={() => handleRetrieve('Risk [ID] has been retrieved')} disabled={createIssueDataLoading}>
                             Retrieve Risk
                        </Button>
                    </div>
            }
            {
                ((issueDetailsData?.issueInformation?.status === STATUS_ENUMS.Active && issueDetailsData?.issueInformation?.level1 === STATUS_ENUMS.Rejected && issueDetailsData?.issueInformation?.level2 === STATUS_ENUMS.Pending) ||
                ((issueDetailsData?.issueInformation?.status === STATUS_ENUMS.Active || issueDetailsData?.issueInformation?.status === STATUS_ENUMS.DisputeClosed) &&
                issueDetailsData?.issueInformation?.level2 === STATUS_ENUMS.Rejected)) && !isEditTrue &&
                    <div className='flex justify-end items-center gap-6 pr-4 h-[10%]'>
                        <div className='flex items-center gap-6'>
                            <div className='text-primary underline  cursor-pointer' onClick={() => setIsViewComments({ right: true })}>View Comments</div>

                            {((issueDetailsData?.issueInformation?.level2 === STATUS_ENUMS.Rejected && issueDetailsData?.issueInformation?.roles?.includes('Risk Manager') && issueDetailsData?.issueInformation?.department === userDepartment && issueDetailsData?.issueInformation?.status !== STATUS_ENUMS.DisputeClosed)) &&
                            <Button variant='outline' onClick={() => handleDisMove('Risk [ID] has been raised as a dispute')} disabled={createIssueDataLoading}>
                                        Dispute
                            </Button>}
                            {(((issueDetailsData?.issueInformation?.createdBy === +userId || verifyManagerOrVacant()) && issueDetailsData?.issueInformation?.level2 === STATUS_ENUMS.Pending && issueDetailsData?.issueInformation?.level1 === STATUS_ENUMS.Rejected && issueDetailsData?.issueInformation?.department === userDepartment) ||
                            (issueDetailsData?.issueInformation?.level2 === STATUS_ENUMS.Rejected && issueDetailsData?.issueInformation?.roles?.includes('Risk Manager') && issueDetailsData?.issueInformation?.department === userDepartment)) &&
                            <Button onClick={() => handleRejAccept()} disabled={createIssueDataLoading}>
                                    Accept
                            </Button>}

                        </div>
                    </div>
            }

            {
                issueDetailsData?.issueInformation?.status === STATUS_ENUMS.Resubmit &&
                    <div className='flex justify-end items-center gap-6 pr-4 h-[10%]'>
                        <div className='flex items-center gap-6'>
                            <div className='text-primary underline  cursor-pointer' onClick={() => setIsViewComments({ right: true })}>View Comments</div>
                            <Button onClick={() => {
                                const reqBody = {
                                    recipientUserId: issueDetailsData?.issueInformation?.level1 === 11 && issueDetailsData?.issueInformation?.level2 === 8 ? issueDetailsData?.issueInformation?.raisedId : issueDetailsData?.issueInformation?.ownerId,
                                    message: `Changes to Issue ${issueDetailsData?.issueInformation?.referenceId} have been Updated. Awaiting your approval.`,
                                    kind: 3
                                }
                                instance.post(EndPoints.BASE_ENDPOINT + '/api/v1/core/Notification/send', reqBody)
                                handleAddRisk(issueDetailsData?.issueInformation?.level1 === STATUS_ENUMS.Rejected && issueDetailsData?.issueInformation?.level2 === STATUS_ENUMS.Pending ? { level1: STATUS_ENUMS.Pending, level2: STATUS_ENUMS.Pending, status: STATUS_ENUMS.Active } : { level1: STATUS_ENUMS.Approved, level2: STATUS_ENUMS.Pending, status: STATUS_ENUMS.Active })
                            }}
                            disabled={createIssueDataLoading}
                            >
                                Resubmit
                            </Button>
                        </div>
                    </div>
            }

            {
                issueDetailsData?.issueInformation?.status === STATUS_ENUMS.Dispute && issueDetailsData?.issueInformation?.level2 === STATUS_ENUMS.Rejected && issueDetailsData?.issueInformation?.ownerDepartmentId === userDepartment && verifyManagerOrVacant() && !isEditTrue &&
                    <div className='flex justify-end items-center gap-6 pr-4 h-[10%]'>
                        <Button onClick={() => handleDisReject()}
                            variant='outline'
                            style={{ color: 'hsl(var(--destructive))', borderColor: 'hsl(var(--destructive))' }}
                            disabled={createIssueDataLoading}
                        >
                            Reject
                        </Button>
                        <Button onClick={() => handleDisApprove()} disabled={createIssueDataLoading}>
                             Approve
                        </Button>
                    </div>
            }
            {/* </div> */}
            {/* </div> */}
            <Dialog
                maxWidth
                open={openWithdrawnPopup}
            >
                <Box sx={{ width: 400 }} >
                    <DialogTitle sx={{ padding: '0px 10px 0px 10px', display: 'flex', alignItems: 'center', backgroundColor: 'hsl(var(--destructive))', flexDirection: 'row', height: '40px', justifyContent: 'center' }}>
                        <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#fff' }}>Warning</div>
                    </DialogTitle>
                    <DialogContent sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'col', justifyContent: 'center', alignItems: 'center' }}>
                        <p className='text-muted pt-[24px] text-[14px]'>
                            {`This Risk has been already withdrawn. ${'You'} can't proceed further`}
                        </p>
                    </DialogContent>
                    <DialogActions style={{ borderTop: '2px solid hsl(var(--border))', width: '100%', display: 'flex', padding: '15px 30px 15px 30px', flexDirection: 'row', justifyContent: 'flex-end' }}>
                        <div className='d-flex content-end'>
                            <Button
                                variant='outline'
                                style={{ color: 'hsl(var(--destructive))', borderColor: 'hsl(var(--destructive))' }}
                                onClick={() => {
                                    navigate(RoutePath.MAIN_CONTAINER.MAIN + RoutePath.RISK.URI + '/' + INITIATE)
                                    setOpenWithdrawnPopup(false)
                                }}
                            >
                                {'Close'}
                            </Button>
                        </div>
                    </DialogActions>
                </Box>
            </Dialog>
            <Dialog open={openConfirmDialog} onClose={() => setOpenConfirmDialog(false)}>
                <Box className='md:w-[400px] lg:w-[600px]'>
                    <DialogTitle sx={{ padding: '0px 10px 0px 10px', display: 'flex', alignItems: 'center', backgroundColor: 'hsl(var(--primary))', flexDirection: 'row', height: '40px', justifyContent: 'center' }}>
                        <h1 className='md:text-lg lg:text-xl font-bold text-[#fff]' style={{ fontSize: '20px', fontWeight: 'bold', color: '#fff' }}>Withdraw Confirmation</h1>
                    </DialogTitle>
                    <DialogContent sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'col', justifyContent: 'center', alignItems: 'center' }}>
                        <p className='text-muted pt-[24px] md:text-[14px] lg:text-[16px]'>
                            {/* {`Do you want to withdraw the risk ID ${selectedRiskId} ?`} */}
                        </p>
                    </DialogContent>
                    <DialogActions style={{ borderTop: '2px solid hsl(var(--border))', width: '100%', display: 'flex', padding: '15px 30px 15px 30px', flexDirection: 'row', justifyContent: 'flex-end' }}>
                        <Button variant="outline" onClick={() => setOpenConfirmDialog(false)}>
                            No
                        </Button>
                        <Button onClick={confirmWithdraw} style={{ color: '#fff', backgroundColor: 'hsl(var(--primary))' }}>
                            Yes
                        </Button>
                    </DialogActions>
                </Box>
            </Dialog>

            <ViewComments
                isViewComments={isViewComments}
                setIsViewComments={setIsViewComments}
            />
            <Dialog
                // open={preApprovalPopup}
                // onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle sx={{ padding: '0px 10px 0px 10px', display: 'flex', alignItems: 'center', backgroundColor: 'hsl(var(--primary))', flexDirection: 'row', height: '40px', justifyContent: 'center' }}>
                    <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#fff' }}>Information</div>
                </DialogTitle>
                <DialogContent style={{ padding: '15px 30px 15px 30px' }}>
                    <DialogContentText id="alert-dialog-description">
                                    This risk will be auto-approved as the Creator and Approver are the same person.
                    </DialogContentText>
                </DialogContent>
                <DialogActions style={{ borderTop: '2px solid hsl(var(--border))', width: '100%', display: 'flex', padding: '15px 30px 15px 30px', flexDirection: 'row', justifyContent: 'flex-start' }}>
                    <div className='d-flex content-end'>
                        <Button
                            style={{ borderColor: 'hsl(var(--primary))' }}
                            onClick={() => {
                                let status = statusEnum
                                status = { ...status, level1: STATUS_ENUMS.Approved, status: STATUS_ENUMS.Active }
                                setStatusEnum({ ...statusEnum, level1: STATUS_ENUMS.Approved, status: STATUS_ENUMS.Active })
                                handleAddRisk(status, 'Risk [ID] has been accepted')
                            }}
                        >
                            {'Yes, Proceed'}
                        </Button>
                    </div>
                </DialogActions>
            </Dialog>
            <CommentsDrawer handleReject={handleReject} setEditState={setEditState} editState={editState} comments={comments} setComments={setComments} loading={createIssueDataLoading} title={CommentsDrawerTitle}/>
        </div>
    )
}

export default ViewIssueById
